<template>
    <UserPreferencesForm
        ref="form"
        v-bind="$props"
        :key="notificationPreferencesKey"
        @reset="$emit('reset')"
        @success="$emit('success')"
        @editing="$emit('editing', $event)"
        @submit="$emit('submit')"
    />
</template>

<script>
import UserPreferencesForm from "./UserPreferencesForm.vue";

export default {
    components: {
        UserPreferencesForm,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        notificationPreferences: {
            type: Object,
            default: () => ({}),
        },
        relationships: {
            type: Array,
            default: () => [],
        },
        rules: {
            type: Object,
            default: () => ({}),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        notificationPreferencesKey() {
            return !!Object.keys(this.notificationPreferences).length;
        },
    },
    methods: {
        save() {
            this.$refs.form.save();
        },
        cancel() {
            this.$inertia.visit(this.$page.url);
        },
    },
};
</script>
